import { render, staticRenderFns } from "./NotificationMessageCard.vue?vue&type=template&id=04b05ab1&"
import script from "./NotificationMessageCard.vue?vue&type=script&lang=js&"
export * from "./NotificationMessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports